import { render, staticRenderFns } from "./Overflow.vue?vue&type=template&id=06088880&scoped=true&"
import script from "./Overflow.vue?vue&type=script&lang=js&"
export * from "./Overflow.vue?vue&type=script&lang=js&"
import style0 from "./Overflow.vue?vue&type=style&index=0&id=06088880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06088880",
  null
  
)

export default component.exports